import { Product } from "@/types/product";
import { searchClient } from "@/lib/algolia";

export const calculateStats = (products: Product[]) => {
  if (products.length === 0) return { avgPrice: 0, totalRatings: 0, avgRating: 0 };
  
  const totalPrice = products.reduce((sum, product) => sum + product.price, 0);
  const totalRatings = products.reduce((sum, product) => sum + product.rating_amount, 0);
  const weightedRatingSum = products.reduce(
    (sum, product) => sum + (product.average_rating * product.rating_amount),
    0
  );
  
  return {
    avgPrice: totalPrice / products.length,
    totalRatings,
    avgRating: totalRatings > 0 ? weightedRatingSum / totalRatings : 0
  };
};

export const performSearch = async (query: string) => {
  if (!query || query.length < 2) {
    return { hits: [], nbHits: 0 };
  }

  try {
    console.log("Searching for:", query);
    const index = searchClient.initIndex('prod_de_attributes');
    const result = await index.search<any>(query, {
      timeout: 5000,
      headers: {
        'X-Algolia-UserToken': 'anonymous'
      }
    });
    console.log("Search results:", result.hits);

    const validatedHits: Product[] = result.hits.map(hit => ({
      objectID: hit.objectID || hit.s_id?.toString() || '',
      title: hit.p_title?.trim() || 'Untitled Product',
      price: typeof hit.p_price === 'number' ? hit.p_price : 0,
      image_url: hit.p_image_url || '/placeholder.svg',
      average_rating: typeof hit.p_rating_value === 'number' ? hit.p_rating_value / 2 : 0,
      rating_amount: typeof hit.p_rating_count === 'number' ? hit.p_rating_count : 0,
      ean: hit.p_ean || 'N/A',
      slug: hit.p_slug || 'N/A',
      brand: hit.p_brand || 'Unknown Brand',
      in_stock: !hit.p_availability?.toLowerCase().includes('nicht'),
      p_availability: hit.p_availability || 'Unknown',
      p_attributes: hit.p_attributes || {},
      domain: hit.domain || 'Unknown Domain'
    }));

    return { hits: validatedHits, nbHits: result.nbHits };
  } catch (error) {
    console.error("Search error:", error);
    throw error;
  }
};